import Icon, {IconName} from 'external/fortawesome'
import {FC, Dropdown, Link} from 'external/react'

type MenuItemProps = {
    icon: IconName,
    label: string,
    to: string    
}

const MenuItem: FC<MenuItemProps> = props => {
    const {icon, label, to} = props
    return (
        <Dropdown.Item as={Link} to={to}>
            <span>
                <Icon style={{width: '17px'}} name={icon} /> {label}
            </span>
        </Dropdown.Item>
       
    )
}

export {MenuItem as default}